export class TemporaryTaskChangedEvent {}
